import React from "react";
import Box from "@mui/material/Box";
import moment from "moment";
import styles from "../../Helpers/styles";
import { is_gsec_sdl_tBill, sortDate, toINR } from "../../Helpers/functions";

const CashflowPDF = ({
  bondDetails,
  inputvalues,
  cashflow,
}: {
  bondDetails: any;
  inputvalues: any;
  cashflow: any;
}) => {
  return (
    <>
      {/* PDF Content Below */}
      <Box component="table" id="redCard-heading" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Cashflow for {bondDetails?.isin}</th>
          </tr>
        </thead>
      </Box>
      <Box component="table" id="redCard-disclaimer" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>
              Disclaimer: The actual dates and interest amounts can vary
              depending on Bank closures, holidays etc. Tax Deducted at Source
              (TDS) is applicable on interest receivable based on relevant tax
              regulations. You can avail TDS credit while filing your Income Tax
              Return (ITR).
            </th>
          </tr>
        </thead>
      </Box>
      {/* Basic Info Below */}
      <Box component="table" id="redCard-issuerName" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Security Name</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{bondDetails?.securityName}</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-creditRating" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Credit Rating</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {bondDetails?.ratingOrganizationMasters
                ?.map(
                  ({ rating: { rating }, organization: { name } }: any) => ({
                    rating,
                    ratingOrg: name,
                  })
                )
                .map((value: any, index: any) => (
                  <React.Fragment key={index}>
                    <Box component={"span"}>{value.rating}</Box>
                    <Box component={"span"} sx={styles.label}>
                      {" "}
                      by{" "}
                    </Box>
                    <Box component={"span"} sx={{ color: "info.main" }}>
                      {value.ratingOrg}
                    </Box>
                    <br />
                  </React.Fragment>
                ))}
            </td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-frequency" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Coupon Frequency</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{bondDetails?.frequencyOfInterest}</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-faceValue" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Face Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{toINR(bondDetails?.faceValue.split(" ")[0], 4)}</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-coupon" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Coupon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{bondDetails?.coupons[0].rate}%</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-ytmYtc" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>YTM or YTC</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{bondDetails?.callOptions?.length ? "YTC" : "YTM"}</td>
          </tr>
        </tbody>
      </Box>
      <Box
        component="table"
        id="redCard-callOrMaturityDate"
        sx={{ display: "none" }}
      >
        <thead>
          <tr>
            <th>
              {bondDetails?.callOptions?.at(-1)?.date
                ? "Call Date"
                : "Maturity Date"}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {bondDetails?.callOptions?.at(-1)?.date
                ? bondDetails?.callOptions
                    ?.sort((a: any, b: any) => sortDate(a, b))
                    .at(-1)?.date
                : bondDetails?.maturities
                    ?.sort((a: any, b: any) => sortDate(a, b))
                    .at(-1)?.date}
            </td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-security" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Security</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{bondDetails?.securedOrUnsecured}</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-noOfBonds" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>No. of Bonds</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{inputvalues?.count}</td>
          </tr>
        </tbody>
      </Box>
      <Box
        component="table"
        id="redCard-settlementDate"
        sx={{ display: "none" }}
      >
        <thead>
          <tr>
            <th>Settlement Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{inputvalues?.settlementDate}</td>
          </tr>
        </tbody>
      </Box>
      <Box
        component="table"
        id="redCard-principalAmount"
        sx={{ display: "none" }}
      >
        <thead>
          <tr>
            <th>Principal Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{inputvalues?.principle}</td>
          </tr>
        </tbody>
      </Box>
      <Box
        component="table"
        id="redCard-accruedInterest"
        sx={{ display: "none" }}
      >
        <thead>
          <tr>
            <th>Accrued Interest</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{inputvalues?.accruedInterest}</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-stampDuty" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Stamp Duty</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{inputvalues?.stampDuty}</td>
          </tr>
        </tbody>
      </Box>
      <Box
        component="table"
        id="redCard-settlementAmount"
        sx={{ display: "none" }}
      >
        <thead>
          <tr>
            <th>Total Amount Payable</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{inputvalues?.totalConsideration}</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-price" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{toINR(inputvalues?.price, 4)}</td>
          </tr>
        </tbody>
      </Box>
      <Box component="table" id="redCard-yield" sx={{ display: "none" }}>
        <thead>
          <tr>
            <th>Yield</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{inputvalues?.yield}%</td>
          </tr>
        </tbody>
      </Box>
      {/* Actual Cashflow Below */}
      <Box
        component="table"
        id="redCard-cashflowTable"
        sx={{ display: "none" }}
      >
        <thead>
          <tr>
            <th>Year</th>
            <th>Payment Date</th>
            <th>Amount</th>
            {!(
              is_gsec_sdl_tBill(bondDetails?.securityType.type!) ||
              bondDetails?.taxCategory === "Tax Free"
            ) && <th>Amount after TDS</th>}
            <th>Payout Type</th>
          </tr>
        </thead>
        <tbody>
          {(cashflow ?? []).map(({ date, amount, type }: any, index: any) => (
            <tr key={index}>
              <td>{moment(date, "DD/MM/YYYY").format("YYYY")}</td>
              <td>{moment(date, "DD/MM/YYYY").format("DD MMM")}</td>
              <td>
                {toINR(
                  (amount as number) *
                    (isNaN(inputvalues?.count!) ? 1 : inputvalues?.count!),
                  2
                )}
              </td>
              {!(
                is_gsec_sdl_tBill(bondDetails?.securityType.type!) ||
                bondDetails?.taxCategory === "Tax Free"
              ) && (
                <td>
                  {toINR(
                    (amount as number) *
                      (isNaN(inputvalues?.count!) ? 1 : inputvalues?.count!) *
                      (type === "Interest" ? 0.9 : 1),
                    2
                  )}
                </td>
              )}
              <td>{type}</td>
            </tr>
          ))}
        </tbody>
      </Box>
    </>
  );
};

export default CashflowPDF;
